<template>
  <div class="album column is-2-desktop is-3-tablet is-6-mobile">
    <album-cover
      v-bind:album="this.album"
      v-on:cover-click="viewAlbum"
      class="album-cover is-square poly-cursor-pointer"
    >
      <span v-if="isPlaying" v-on:click="togglePlay" class="state-icon icon is-large has-text-black is-overlay poly-hidden poly-visible-touch">
        <i class="mdi mdi-24px mdi-pause"></i>
      </span>
      <span v-else v-on:click="togglePlay" class="state-icon icon is-large is-overlay has-text-black poly-hidden poly-visible-touch">
        <i class="mdi mdi-24px mdi-play"></i>
      </span>
    </album-cover>

    <dl style="margin-top:0.4rem;">
      <dd class="album-name has-text-weight-bold poly-truncate">
        <router-link v-bind:to="{ name: 'album', params: { id: album.id } }">
          {{ album.name }}
        </router-link>
      </dd>
      <dd class="album-artist has-text-grey-light has-text-weight-semibold">
        <template v-if="showReleaseDate">
          {{ album.releaseDate }}
        </template>
        <template v-else>
          <ul class="album-artists poly-truncate">
            <li
              v-for="(artist, index) in album.artists"
              v-bind:key="artist.id"
            >
              <span v-if="index > 0">, </span>
              <router-link v-bind:to="{ name: 'artist', params: { id: artist.id } }" class="has-text-grey-light">{{ artist.name }}</router-link>
            </li>
          </ul>
        </template>
      </dd>
    </dl>
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'

  export default {
    name: 'AlbumListItem',
    components: {
      AlbumCover
    },
    props: {
      album: {
        type: Object,
        required: true
      },
      showReleaseDate: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isPlaying: function () {
        return(
          this.$store.getters.isPlaying &&
          this.$store.getters.currentAlbum &&
          this.$store.getters.currentAlbum.id === this.album.id
        )
      },
      isPaused: function () {
        return(
          this.$store.getters.isPaused &&
          this.$store.getters.currentAlbum &&
          this.$store.getters.currentAlbum.id === this.album.id
        )
      },
      isStopped: function () {
        return(
          this.$store.getters.isStopped ||
          (
            this.$store.getters.currentAlbum &&
            this.$store.getters.currentAlbum.id !== this.album.id
          )
        )
      }
    },
    methods: {
      togglePlay: function () {
        if (this.isStopped) {
          this.fetchAlbumTracks().then((response) =>
            this.$store.commit('playTracks', { tracks: response.data.tracks })
          ).catch(() =>
            console.error(`There was an error trying to get tracks for album with id ${this.album.id}`)
          )
        } else {
          this.$store.commit('togglePlay')
        }
      },
      fetchAlbumTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/AlbumTracks.gql'),
          variables: { albumId: this.album.id }
        })
      },
      viewAlbum: function () {
        this.$router.push({ name: 'album', params: { id: this.album.id }})
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .album { padding-bottom: 0.2rem !important; }
  .album-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .album-cover:hover .state-icon { visibility: visible; }
  .album-artists li { display: inline; }
  .album-artist {
    font-size: 0.85rem;
    margin-top: -0.16rem;
  }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .album-name { font-size: 0.9rem; }
    .state-icon {
      margin-left: 0.3rem;
      margin-bottom: 0.3rem;
      transform: scale(0.8);
    }
  }
</style>
